import IconButton from "components/IconButton";
import { useContext, useEffect, useState } from "react";
import { Button, Table } from "reactstrap";
import AppContext from "AppContext";
import descarteService from "services/DescarteService";
import { confirm } from "components/Confirmation";
import { toast } from "react-toastify";

export default function Componentes({ items, onAdd, onDelete }) {
  return (
    <>
      <div className="d-flex flex-row justify-content-end align-items-center pb-4">
        <Button color="primary" onClick={onAdd}>Incluir Componente</Button>
      </div>

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">QRCode</th>
            <th scope="col">Tipo</th>
            <th scope="col">Modelo</th>
            <th scope="col">Estado</th>
            <th scope="col" style={{ width: 60 }}></th>
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={5} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.qrCode}</td>
              <td>{el.tipoComponente}</td>
              <td>{el.modelo}</td>
              <td>{el.estadoFmt}</td>
              <td className="d-flex flex-row gap-5px">
                <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => onDelete && onDelete(el)} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}